import { DateNavigatorMobile } from '@/domain/mitarbeiter/features/feiertagskonto/components/dateNavigation';
import { NavigationBackToV1 } from '@/domain/mitarbeiter/features/feiertagskonto/components/NavigationBackToV1';
import { useFeiertagskonto } from '@/domain/mitarbeiter/features/feiertagskonto/hooks/useFeiertagskonto/useFeiertagskonto';
import { useUpdateFeiertagskontoEinstellungen } from '@/domain/mitarbeiter/features/feiertagskonto/hooks/useUpdateFeiertagskontoEinstellungen/useUpdateFeiertagskontoEinstellungen';
import { useYearPickerContext } from '@/domain/mitarbeiter/features/feiertagskonto/shared/YearPickerContext';
import {
  DesktopPage,
  MobilePage,
} from '@/domain/mitarbeiter/pages/feiertagskonto/overview';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { useIsMobile } from '@/hooks/useIsMobile';
import { LoadingPage } from '@/pages';
import { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export function FeiertagskontoPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const isMobile = useIsMobile();
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { zeitraum } = useYearPickerContext();
  const { feiertagskontoEinstellungen } = useFeiertagskonto({
    mitarbeiterId: id,
    zeitraum: zeitraum,
    standortId: standortId,
  });
  const [updateFeiertagskontoEinstellungen] =
    useUpdateFeiertagskontoEinstellungen();

  const handleChange = async () => {
    if (feiertagskontoEinstellungen.isFeiertagskontoAktive === true) {
      await updateFeiertagskontoEinstellungen({
        input: {
          mitarbeiterId: id,
          feiertagskontoAktiv: false,
        },
      });
    } else {
      await updateFeiertagskontoEinstellungen({
        input: {
          mitarbeiterId: id,
          feiertagskontoAktiv: true,
        },
      });
    }
  };
  return (
    <>
      <Helmet>
        <title>{t('domain.mitarbeiter.feiertagskonto.title')}</title>
      </Helmet>
      <Suspense fallback={<LoadingPage />}>
        {isMobile ? (
          <div className=" bg-neutrals-v2-200 flex flex-col">
            <div className="flex flex-col">
              <DateNavigatorMobile />
              <div className="flex flex-col gap-6 p-4">
                <NavigationBackToV1
                  name={feiertagskontoEinstellungen.mitarbeiterName}
                />
                <MobilePage
                  isActive={feiertagskontoEinstellungen.isFeiertagskontoAktive}
                  handleChange={handleChange}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className=" p-10 bg-neutrals-v2-200 flex flex-col gap-6">
            <div className="flex flex-col gap-6">
              <NavigationBackToV1
                name={feiertagskontoEinstellungen.mitarbeiterName}
              />
            </div>
            <div className="hidden md:block">
              <DesktopPage
                isActive={feiertagskontoEinstellungen.isFeiertagskontoAktive}
                handleChange={handleChange}
              />
            </div>
          </div>
        )}
      </Suspense>
    </>
  );
}
